import React from "react";

const DEFAULT_ITEMS = ["התשלום התקבל", "החשבון נפתח", "פרטי הגישה נשלחו"];

/**
 * Checklist status block. Pass `items` to override; `note` for optional dynamic copy (e.g. API message).
 */
export default function SuccessStatus({ items = DEFAULT_ITEMS, note }) {
  return (
    <section className="success-reg-status" aria-label="סטטוס הרשמה">
      <ul className="success-reg-status__list">
        {items.map((text) => (
          <li key={text} className="success-reg-status__item">
            <span className="success-reg-status__check" aria-hidden>
              ✓
            </span>
            <span>{text}</span>
          </li>
        ))}
      </ul>
      {note ? <p className="success-reg-status__note">{note}</p> : null}
    </section>
  );
}
